import React from 'react';
import { ApIcon, colors } from '@alixpartners/ui-components';

import {
	Wrapper,
	Header,
	HeaderLabel,
	Content,
	IconWrapper,
	SubheaderLabel,
} from './Collapsible.styles';

export class Collapsible extends React.Component {
	static defaultProps = {
		isOpen: false,
	};

	state = {
		isCollapsed: !this.props.isOpen,
	};

	componentDidUpdate(prevProps) {
		const { isOpen } = this.props;

		if (isOpen !== prevProps.isOpen) {
			this.setState({ isCollapsed: !isOpen });
		}
	}

	toggle = () => {
		const { afterToggle } = this.props;

		this.setState({ isCollapsed: !this.state.isCollapsed });

		if (afterToggle) {
			afterToggle();
		}
	};

	render() {
		const {
			header,
			headerClassName,
			children,
			onClick,
			wrapperClassName,
			subheader,
		} = this.props;
		const { isCollapsed } = this.state;
		const toggleHandler = onClick ? onClick : this.toggle;

		return (
			<Wrapper className={wrapperClassName}>
				<Header className={headerClassName} onClick={toggleHandler}>
					<IconWrapper isCollapsed={isCollapsed} onClick={toggleHandler}>
						<ApIcon
							iconName="baseline_keyboard_arrow_right"
							iconColor={colors.grey8}
						/>
					</IconWrapper>

					{typeof header === 'string' ? (
						<React.Fragment>
							<HeaderLabel>{header}</HeaderLabel>
							{subheader && <SubheaderLabel>{subheader}</SubheaderLabel>}
						</React.Fragment>
					) : (
						header()
					)}
				</Header>
				{!isCollapsed && <Content>{children}</Content>}
			</Wrapper>
		);
	}
}

export default Collapsible;
